export default "__VITE_ASSET__DR6wziVv__"